import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledNavBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
`;

export const StyledNavigationBarList = styled.ul`
  display: flex;
  align-items: center;
`;

export const StyledNavigationBarItem = styled.li`
  display: flex;
  align-items: center;
  text-align: center;
  list-style: none;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  border: 0;
  outline: 0;
  color: ${themeGet('colors.menu.color')};
  font-family: ${themeGet('fonts.menu')};
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};

  &:hover {
    color: ${themeGet('colors.menu.hover')};
  }
`;

export const StyledUserAccount = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledText = styled.span`
  display: flex;
  align-items: center;
  margin-right: 25px;
  padding: 9px 15px;
  background-color: #f6f7fa;
  border-radius: ${themeGet('radii.base')};
  color: ${themeGet('colors.menu.color')};
  font-family: ${themeGet('fonts.menu')};
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.semi')};

  svg {
    margin-right: 15px;
  }
`;

export const StyledBtn = styled.button`
  display: flex;
  align-items: center;
  border: none;
  padding: 9px 30px;
  background-color: #f6f7fa;
  border-radius: ${themeGet('radii.base')};
  color: ${themeGet('colors.menu.color')};
  font-family: ${themeGet('fonts.menu')};
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.semi')};

  svg {
    margin-right: 15px;
  }

  &:hover {
    color: ${themeGet('colors.menu.hover')};
  }
`;
